export interface SiteMetaData {
    id: number
    name: string
    city: string
    country: string
    countryCode: string
    latitude: number
    longitude: number
    brand: string
    subBrand: string | null
    fund: string
    financialPartners: string[]
    hotelGroups: string[]
    acquisitionDate: string
    assetStatus: string
    stars: number
    surface: number
}

export enum SeriesTypes {
    ENERGY = 'energy',
    WATER = 'water',
    OCCUPANCY = 'occupancy',
}

export enum EnergySubtypes {
    ELECTRICITY = 'electricity',
    GAS = 'gas',
    HEAT = 'heat',
    OTHER = 'other',
}

interface SeriesDataPoint {
    date: string // eg 2024-01
    value: number
}

type SeriesData = SeriesDataPoint[]

export interface Series {
    type: SeriesTypes
    subType: EnergySubtypes | null
    data: SeriesData
}

type DpeType = 'consumption' | 'emission'
type DpeLabel = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G'
export interface DpeFullLabel {
    label: DpeLabel
    value: number
    unit: string
}

export interface SiteData extends SiteMetaData {
    series: Series[]
    dpe: Record<DpeType, DpeFullLabel>
    completionRate: number
}

export const CATEGORY_FILTERS = ['brand', 'subBrand', 'fund', 'stars', 'country'] as const

export type CategoryFilterKey = (typeof CATEGORY_FILTERS)[number]

export const categoryFilterKeyTranslations: Record<string, string> = {
    brand: 'Marque',
    subBrand: 'Enseigne',
    fund: 'Fond',
    stars: 'Étoiles',
    city: 'Ville',
    country: 'Pays',
    financialPartners: 'Partenaires financiers',
    hotelGroups: "Groupes hôteliers présents dans l'affaire",
}
